import {
  BaseStandardDocumentDto,
  BaseStandardDto,
} from "../application/application.dto";
import { ArfDictionaryItemDto } from "../dictionaries/dictionaries.dto";
import { SectorDto } from "../sectors/sectors.dto";
import { StandardDto } from "../standards/standards.dto";

export interface GeneralUnitDto {
  id: number;
  baseStandardId: number;
  baseStandard?: BaseStandardDto;
  name: string;
  type?: UnitType;
  countryId: number;
  country?: ArfDictionaryItemDto;
  provinceId: number;
  province?: ArfDictionaryItemDto;
  district: string;
  address: string;
  postCode: string;
  contactPersonName: string;
  contactPersonEmail?: string;
  contactPersonPhoneNumber?: string;
  contactPersonPhoneCode?: string;
  certificationRequestedStandards?: string[]; // seçilenler arasında tüm standartlar
  processTypes?: ProcessTypeOfGeneralStandardDto[];
  processTypesIds?: number[];
  femaleEmployeesCount?: number;
  maleEmployeesCount?: number;
  areTaxPlatesTheSameAsApplicantCompany?: boolean;
  doesTheSubunitHaveJointOwnershipWithApplicantCompany?: boolean;
  hasCertificateByAnotherCertificationBody?: boolean;
  standardsByAnotherCertificationBody?: string[]; // tekstilin tüm standartları
  anotherCertificationBodyName?: string;
  lastDayOfInspection?: Date | null;
  certificationExpireDate?: Date | null;
  hasSubunitReceivedNonCompliance?: boolean;
  wasNonConformitiesBeenClosed?: boolean;
  hasSubunitAnySocialCertificationAudit?: boolean;
  socialCertificationAuditNames?: string;
  effectiveDate?: Date | null;
  //yeni
  doYouHaveASubcontractorAgreement?: boolean;
  certifiedBusiness?: boolean;
  certifiedBusinessFileIds?: string[];
  certifiedBusinessFiles?: BaseStandardDocumentDto[];
  subcontractorFileIds?: string[];
  subcontractorFiles?: BaseStandardDocumentDto[];
  availableCertificationFileIds?: string[];
  availableCertificationFiles?: BaseStandardDocumentDto[];
}
interface ProcessTypeOfGeneralStandardDto {
  id: number;
  generalStandardId: number;
  processTypeId: number;
  processType: ProcessTypeDto;
}

interface ProcessTypeDto {
  code: string;
  name: string;
  sectorId: number;
  sector: SectorDto;
  standardId: number;
  standard: StandardDto;
}

export interface GeneralUnitCreateDto {
  baseStandardId: number;
  name: string;
  countryId: number;
  provinceId: number;
  district: string;
  address: string;
  postCode: string;
  contactPersonName: string;
  contactPersonEmail?: string;
  contactPersonPhoneNumber?: string;
  contactPersonPhoneCode?: string;
  certificationRequestedStandards?: string[]; // seçilenler arasında tüm standartlar
  processTypesIds?: number[];
  femaleEmployeesCount?: number;
  maleEmployeesCount?: number;
  areTaxPlatesTheSameAsApplicantCompany?: boolean;
  doesTheSubunitHaveJointOwnershipWithApplicantCompany?: boolean;
  hasCertificateByAnotherCertificationBody?: boolean;
  standardsByAnotherCertificationBody?: string[]; // tekstilin tüm standartları
  anotherCertificationBodyName?: string;
  lastDayOfInspection?: Date | null;
  certificationExpireDate?: Date | null;
  hasSubunitReceivedNonCompliance?: boolean;
  wasNonConformitiesBeenClosed?: boolean;
  hasSubunitAnySocialCertificationAudit?: boolean;
  socialCertificationAuditNames?: string;
  effectiveDate?: Date | null;
  // yeni
  doYouHaveASubcontractorAgreement?: boolean;
  certifiedBusiness?: boolean;
  certifiedBusinessFileIds?: string[];
  subcontractorFileIds?: string[];
  type?: UnitType;
  availableCertificationFileIds?: string[];

}

export interface GeneralUnitUpdateDto {
  id: number;
  name: string;
  countryId: number;
  provinceId: number;
  district: string;
  address: string;
  postCode: string;
  contactPersonName: string;
  contactPersonEmail?: string;
  contactPersonPhoneNumber?: string;
  contactPersonPhoneCode?: string;
  certificationRequestedStandards?: string[]; // seçilenler arasında tüm standartlar
  processTypeIds?: number[];
  femaleEmployeesCount?: number;
  maleEmployeesCount?: number;
  areTaxPlatesTheSameAsApplicantCompany?: boolean;
  doesTheSubunitHaveJointOwnershipWithApplicantCompany?: boolean;
  hasCertificateByAnotherCertificationBody?: boolean;
  standardsByAnotherCertificationBody?: string[]; // tekstilin tüm standartları
  anotherCertificationBodyName?: string;
  lastDayOfInspection?: Date | null;
  certificationExpireDate?: Date | null;
  hasSubunitReceivedNonCompliance?: boolean;
  wasNonConformitiesBeenClosed?: boolean;
  hasSubunitAnySocialCertificationAudit?: boolean;
  socialCertificationAuditNames?: string;
  effectiveDate?: Date | null;
  //yeni
  doYouHaveASubcontractorAgreement?: boolean;
  certifiedBusiness?: boolean;
  certifiedBusinessFileIds?: string[];
  subcontractorFileIds?: string[];
  availableCertificationFileIds?: string[];
  type?: UnitType;
}

export enum UnitType {
  Facility = 0,
  Subcontractor = 1,
  CertifiedSubcontractor = 2,
}
